export const userKey = ['review']
export const leftEarlyShifts = [...userKey, 'leftEarlyShifts']
export const adminReviewShifts = [...userKey, 'adminReviewShifts']
